import Movers from '../components/movers/Movers';
import MoversEdit from '../components/movers/MoversEdit';
import MoversPending from '../components/movers/MoversPending';

const Template = {
  template: '<router-view></router-view>',
};

export default {
  path: '/movers',
  component: Template,
  children: [
    {
      path: '',
      name: 'Movers',
      component: Movers,
      meta: {
        title: 'Movers - Mod24',
      },
    },
    {
      path: 'edit/:id',
      name: 'MoversEdit',
      component: MoversEdit,
      meta: {
        title: 'Edit Mover - Mod24',
      },
    },
    {
      path: 'pending',
      name: 'MoversPending',
      component: MoversPending,
      meta: {
        title: 'Pending Movers - Mod24',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/moversRoutes.js